import { toast } from 'sonner';

export const notify = {
  success(message: string) {
    toast.success(message);
  },
  error(message: string) {
    toast.error(message);
  },
  action(message: string, action: { label: string; onClick: () => void }) {
    toast(message, { action });
  },
};
